var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"not-found"}},[_c('b-container',[_c('b-row',{staticClass:"text-center align-items-center justify-content-center"},[_c('img',{attrs:{"src":"/img/404.svg","alt":"404 page not found"}}),_c('h2',{staticClass:"py-5"},[_vm._v("Something went wrong!"),_c('br'),_vm._v(" We can't seem to find the page you are looking for.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }